module.exports = __webpack_public_path__ + "src/assets/sounds/put_sound.mp3";